import React, { ReactNode, useState, useCallback } from "react";

import Header from "../components/Header/header";
import Sidebar from "../components/Main/Sidebar/sidebar";
import Footer from "../components/Footer/Footer";
import "../layouts/styles.css";

type RootLayoutProps = {
  children: ReactNode;
};

export default function RootLayout({ children }: RootLayoutProps) {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const handleToggleSidebar = useCallback(() => {
    setSidebarOpen(prev => !prev);
  }, []);

  const handleCloseSidebar = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  return (
    <div className="container">
      <Header onMenuClick={handleToggleSidebar} />
      <div className="content-wrapper">
        <Sidebar mobileOpen={isSidebarOpen} onToggle={handleToggleSidebar} />
        <main className="main-content" onClick={handleCloseSidebar}>
          {children}
        </main>
      </div>
      <Footer />
    </div>
  );
}
